import React from "react";
import "./style.css";
import SB_Logo from "../../assets/logos/standardbank-logo.png";
import MFT_Logo from "../../assets/logos/MoonfaceTechs-logo.png";
import NMF_Logo from "../../assets/logos/Ntsiki_Logo.png";
import TRR_Logo from "../../assets/logos/TRR_Logo.avif";
import CM_Logo from "../../assets/logos/ControlMag_Logo.avif";

const TrustedBy = () => {
  const clients = [
    { name: "Standard bank", logo: SB_Logo },
    { name: "Moonface Techs", logo: MFT_Logo },
    { name: "Ntsiki Mazwai Foundation", logo: NMF_Logo },
    { name: "Tall Racks Records", logo: TRR_Logo },
    { name: "Control Magazine", logo: CM_Logo },
    { name: "Fulu Media", logo: "FM" },
  ];

  return (
    <section className="trustedby-section">
      <div className="trustedby-container">
        <div className="trustedby-header">
          <h2>Trusted by</h2>
          <p>Industry leaders who choose our creative expertise</p>
        </div>

        {/* Clients */}
        <div className="clients-grid">
          {clients.map((client, index) => (
            <div
              key={client.name}
              className="client-item"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="client-logo">
                <img src={client.logo} alt={client.name} />
              </div>
              <span className="name-label">{client.name}</span>
            </div>
          ))}
        </div>

        {/* Stats */}
        <div className="trustedby-stats">
          <div className="stat">
            <div className="stat-number">150+</div>
            <div className="stat-label">Projects Completed</div>
          </div>
          <div className="stat">
            <div className="stat-number">50+</div>
            <div className="stat-label">Happy Clients</div>
          </div>
          <div className="stat">
            <div className="stat-number">10</div>
            <div className="stat-label">Years Experience</div>
          </div>
          <div className="stat">
            <div className="stat-number">24/7</div>
            <div className="stat-label">Support Available</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustedBy;
